export const ChartType = {
  DONUT: 'Donut',
  SPEED_DIAL: 'Gauge',
  ROUND_BAR: 'RoundBar',
  SCALE_BAR: 'ScaleBar'
} as const

export type ChartTypeStrings = typeof ChartType[keyof typeof ChartType]
